
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { empty as empty_1, singleton as singleton_1, length, ofArray, map as map_1, isEmpty, tryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { unwrap, map, defaultArg, bind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { toLocalTime, toString as toString_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ProcedureStepElementResultValue__ResultToString } from "../../Shared/Procedure.js";
import { ToolState__ToI18nString } from "../../Shared/Tool.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { update as update_1, init as init_1 } from "./State.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { LabeledValue } from "../../Components/Text.js";
import { TextButton } from "../../Components/Button.js";
import Printer from "../../../public/assets/icons/Printer.svg";
import { Msg } from "./Types.js";
import { Skeleton } from "../../Components/Skeleton.js";

function StepResultElement(props) {
    let elems_3;
    const t = useTranslation()[0];
    const result = tryFind((r) => (toString(r.ProcedureTemplateStepElementId) === props.ProcedureTemplateStepElement.Id), props.ProcedureStep.Results);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_3 = toList(delay(() => append((props.ProcedureTemplateStepElement.Type.tag === 1) ? (empty()) : singleton(reactElement("div", {
        className: join(" ", ["font-bold", "mb-1"]),
        children: props.ProcedureTemplateStepElement.Label,
    })), delay(() => {
        let elems_1, elems_2;
        const matchValue_1 = props.ProcedureTemplateStepElement.Type;
        switch (matchValue_1.tag) {
            case 1:
                return singleton(reactElement("div", {
                    className: join(" ", ["p-3", "bg-gray-100", "rounded", "whitespace-pre-wrap", "break-words"]),
                    children: props.ProcedureTemplateStepElement.Label,
                }));
            case 7: {
                const matchValue_3 = bind((r_1) => {
                    if (r_1.Value.tag === 6) {
                        return r_1.SignatureUrl;
                    }
                    else {
                        return undefined;
                    }
                }, result);
                if (matchValue_3 == null) {
                    return singleton(reactElement("div", {
                        className: join(" ", ["text-gray-400", "italic"]),
                        children: t("procedure.no_signature"),
                    }));
                }
                else {
                    const url = matchValue_3;
                    return singleton(reactElement("img", {
                        className: join(" ", ["h-24", "border", "rounded"]),
                        src: url,
                    }));
                }
            }
            case 4: {
                const boolValue = defaultArg(map((r_2) => {
                    const matchValue_4 = r_2.Value;
                    if (matchValue_4.tag === 3) {
                        if (matchValue_4.fields[0]) {
                            return t("general.yes");
                        }
                        else {
                            return t("general.no");
                        }
                    }
                    else {
                        return "-";
                    }
                }, result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: boolValue,
                }));
            }
            case 5: {
                const dateValue = defaultArg(map((r_3) => {
                    const matchValue_5 = r_3.Value;
                    if (matchValue_5.tag === 4) {
                        return toString_1(toLocalTime(matchValue_5.fields[0]), "dd.MM.yyyy");
                    }
                    else {
                        return "-";
                    }
                }, result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: dateValue,
                }));
            }
            case 8:
            case 10: {
                const selectValue = defaultArg(map((_arg_1) => ProcedureStepElementResultValue__ResultToString(_arg_1.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: selectValue,
                }));
            }
            case 9: {
                const multiValues = defaultArg(map((_arg_2) => ProcedureStepElementResultValue__ResultToString(_arg_2.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: multiValues,
                }));
            }
            case 11:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_1 = toList(delay(() => {
                    let elems;
                    return !isEmpty(props.ProcedureTemplateStepElement.Options) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems = toList(delay(() => map_1((imageUrl) => reactElement("img", {
                        className: join(" ", ["rounded", "border", "max-w-full", "max-h-48", "object-contain"]),
                        src: imageUrl,
                    }), props.ProcedureTemplateStepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            case 12: {
                const inspectionValue = defaultArg(map((_arg_3) => ProcedureStepElementResultValue__ResultToString(_arg_3.Value), result), "-");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: inspectionValue,
                }));
            }
            case 14:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: defaultArg(map((_arg_4) => ProcedureStepElementResultValue__ResultToString(_arg_4.Value), result), "-"),
                }));
            case 13: {
                const documentCount = defaultArg(map((r_4) => (length(r_4.DocumentUrls) | 0), result), 0) | 0;
                const documentLabel = t("procedure.document_count");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500"]),
                    children: `${documentCount} ${documentLabel}`,
                }));
            }
            case 15: {
                let displayText;
                const matchValue_6 = map((r_5) => r_5.Value, result);
                let matchResult, state;
                if (matchValue_6 != null) {
                    if (matchValue_6.tag === 14) {
                        if (matchValue_6.fields[0] == null) {
                            matchResult = 1;
                        }
                        else {
                            matchResult = 0;
                            state = matchValue_6.fields[0];
                        }
                    }
                    else {
                        matchResult = 2;
                    }
                }
                else {
                    matchResult = 2;
                }
                switch (matchResult) {
                    case 0: {
                        displayText = t(ToolState__ToI18nString(state));
                        break;
                    }
                    case 1: {
                        displayText = t("procedure.tool_state_change.no_change");
                        break;
                    }
                    default:
                        displayText = "-";
                }
                const displayComment = defaultArg(bind((_arg_5) => _arg_5.Comment, result), "");
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_2 = toList(delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: displayText,
                })), delay(() => ((displayComment !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500"]),
                    children: displayComment,
                })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }
            case 16: {
                let displayText_1;
                const matchValue_7 = map((r_6) => r_6.Value, result);
                let matchResult_1, transfer;
                if (matchValue_7 != null) {
                    if (matchValue_7.tag === 15) {
                        if (matchValue_7.fields[0] != null) {
                            matchResult_1 = 0;
                            transfer = matchValue_7.fields[0];
                        }
                        else {
                            matchResult_1 = 1;
                        }
                    }
                    else {
                        matchResult_1 = 1;
                    }
                }
                else {
                    matchResult_1 = 1;
                }
                switch (matchResult_1) {
                    case 0: {
                        const storageName = defaultArg(map((storage_1) => storage_1.Name, tryFind((storage) => (unwrapStorageId(storage.Id) === transfer.StorageId), props.Storages)), transfer.StorageId);
                        displayText_1 = ((transfer.StorageSpace !== "") ? concat(storageName, " (", transfer.StorageSpace, ...")") : storageName);
                        break;
                    }
                    default:
                        displayText_1 = "-";
                }
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: displayText_1,
                }));
            }
            case 17: {
                let completedCount;
                const matchValue_8 = map((r_7) => r_7.Value, result);
                let matchResult_2, ids;
                if (matchValue_8 != null) {
                    if (matchValue_8.tag === 16) {
                        matchResult_2 = 0;
                        ids = matchValue_8.fields[0];
                    }
                    else {
                        matchResult_2 = 1;
                    }
                }
                else {
                    matchResult_2 = 1;
                }
                switch (matchResult_2) {
                    case 0: {
                        completedCount = length(ids);
                        break;
                    }
                    default:
                        completedCount = 0;
                }
                const completedLabel = t("procedure.reminder_completion.completed_label");
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: `${completedCount} ${completedLabel}`,
                }));
            }
            case 6:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-400", "italic"]),
                    children: "-",
                }));
            default:
                return singleton(reactElement("div", {
                    className: join(" ", ["text-lg", "min-h-[28px]"]),
                    children: defaultArg(map((_arg) => ProcedureStepElementResultValue__ResultToString(_arg.Value), result), "-"),
                }));
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function StepResult(props) {
    let elems_2, elems, elems_1;
    const t = useTranslation()[0];
    const hasResults = defaultArg(map((s) => !isEmpty(s.Results), props.ProcedureStep), false);
    return createElement(SectionContainer, {
        Content: reactElement("div", createObj(singleton_1((elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "mb-4"])], (elems = toList(delay(() => (hasResults ? singleton(reactElement("span", {
            className: join(" ", ["text-green", "text-sm"]),
            children: t("procedure.completed"),
        })) : singleton(reactElement("span", {
            className: join(" ", ["text-gray-400", "text-sm"]),
            children: t("procedure.not_completed"),
        }))))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = toList(delay(() => {
            const matchValue = props.ProcedureStep;
            if (matchValue == null) {
                return singleton(reactElement("div", {
                    className: join(" ", ["text-gray-400", "italic"]),
                    children: t("procedure.no_results"),
                }));
            }
            else {
                const procedureStep = matchValue;
                return map_1((element) => createElement(StepResultElement, {
                    ProcedureStep: procedureStep,
                    ProcedureTemplateStepElement: element,
                    Storages: props.Storages,
                }), props.ProcedureTemplateStep.Elements);
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))),
        Title: props.ProcedureTemplateStep.Name,
    });
}

export function ResultsView(props) {
    let elems_5;
    const t = useTranslation()[0];
    let patternInput_1;
    const init = init_1(props.ProcedureId);
    patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, update_1, (_arg, _arg_1) => {
    }), undefined, [props.ProcedureId]);
    const state_1 = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems_5 = toList(delay(() => {
        const matchValue = state_1.ProcedureForm;
        if (matchValue.tag === 1) {
            const form = matchValue.fields[0];
            return append(singleton(createElement(DetailViewHeader, {
                Badges: empty_1(),
                OnBack: () => {
                    RouterModule_nav(ofArray(["procedure-templates"]), 1, 1);
                },
                SubTitle: unwrap((form.ProcedureTemplate.Description !== "") ? form.ProcedureTemplate.Description : undefined),
                Title: form.ProcedureTemplate.Name,
            })), delay(() => {
                let elems_4;
                return append(singleton(createElement(SectionContainer, {
                    Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_4 = toList(delay(() => {
                        let elems_1, elems, Label;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-start"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-6"])], (elems = toList(delay(() => append(singleton(LabeledValue({
                            Label: t("procedure.start_date"),
                            Value: toString_1(toLocalTime(form.Procedure.StartDate), "dd.MM.yyyy HH:mm"),
                        })), delay(() => {
                            const matchValue_1 = form.Procedure.EndDate;
                            if (matchValue_1 == null) {
                                return empty();
                            }
                            else {
                                const endDate = matchValue_1;
                                return singleton(LabeledValue({
                                    Label: t("procedure.end_date"),
                                    Value: toString_1(toLocalTime(endDate), "dd.MM.yyyy HH:mm"),
                                }));
                            }
                        })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, (Label = t("procedure.download_pdf"), {
                            ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                            Icon: Printer(),
                            Label: Label,
                            OnClick: () => {
                                patternInput_1[1](new Msg(3, []));
                            },
                            TestId: "procedure-results-pdf-button",
                            Variant: "default",
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                            let elems_3, elems_2;
                            return !isEmpty(form.InformationFieldValues) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["border-t", "pt-4"])], (elems_3 = [reactElement("div", {
                                className: join(" ", ["text-sm", "font-bold", "mb-3"]),
                                children: t("procedure.information_fields.title"),
                            }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-4"])], (elems_2 = toList(delay(() => map_1((fieldValue) => LabeledValue({
                                Label: t(fieldValue.Label),
                                Value: (fieldValue.Value !== "") ? fieldValue.Value : "-",
                            }), form.InformationFieldValues))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty();
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))),
                })), delay(() => map_1((templateStep) => createElement(StepResult, {
                    ProcedureStep: unwrap(tryFind((s) => (toString(s.ProcedureTemplateStepId) === templateStep.Id), form.Procedure.Steps)),
                    ProcedureTemplateStep: templateStep,
                    Storages: state_1.Storages,
                }), form.ProcedureTemplate.Steps)));
            }));
        }
        else {
            return singleton(createElement(Skeleton, {
                Variant: "detail",
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))]))));
}

